module.exports = __webpack_public_path__ + "static/icons_startseite-0838b1ec928a4bdb160c8b0c87a43ef6.png";